import { SIGNUP_EVENT } from '@theme/kb-waitlist-form';

const DEFAULT_OPEN_DELAY_MS = 2500;
const TRANSITION_MS = 400;

class KBWaitlistThankYou extends HTMLElement {
  #controller = new AbortController();
  #openTimer = 0;

  connectedCallback() {
    const dialog = this.#dialog;
    if (!dialog) return;

    const { signal } = this.#controller;

    document.addEventListener(
      SIGNUP_EVENT,
      (event) => {
        const source = event?.detail?.source;
        if (!source || source === 'sms') return;
        window.clearTimeout(this.#openTimer);
        this.#openTimer = window.setTimeout(() => this.#open(), this.#openDelayMs);
      },
      { signal }
    );

    const closeButtons = this.querySelectorAll('[data-kb-close]');
    closeButtons.forEach((btn) => {
      btn.addEventListener('click', () => this.#close(), { signal });
    });

    this.addEventListener(
      SIGNUP_EVENT,
      (event) => {
        const source = event?.detail?.source;
        if (source === 'sms') {
          setTimeout(() => this.#close(), 1800);
        }
      },
      { signal }
    );

    dialog.addEventListener(
      'cancel',
      (event) => {
        event.preventDefault();
        this.#close();
      },
      { signal }
    );
  }

  disconnectedCallback() {
    window.clearTimeout(this.#openTimer);
    this.#controller.abort();
  }

  /** @returns {HTMLDialogElement | null} */
  get #dialog() {
    const dialog = this.querySelector('dialog');
    return dialog instanceof HTMLDialogElement ? dialog : null;
  }

  get #openDelayMs() {
    const raw = parseFloat(this.dataset.openDelay ?? '');
    if (!Number.isFinite(raw) || raw < 0) return DEFAULT_OPEN_DELAY_MS;
    return Math.round(raw * 1000);
  }

  #open() {
    const dialog = this.#dialog;
    if (!dialog) return;
    if (typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => dialog.classList.add('is-visible'));
    });
  }

  #close() {
    const dialog = this.#dialog;
    if (!dialog) return;
    dialog.classList.remove('is-visible');
    const finalize = () => {
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      document.body.style.overflow = '';
    };
    window.setTimeout(finalize, TRANSITION_MS);
  }
}

if (!customElements.get('kb-waitlist-thank-you')) {
  customElements.define('kb-waitlist-thank-you', KBWaitlistThankYou);
}

export { KBWaitlistThankYou };
